import BaseStore from '../../../../../../components/BaseStore'

export default {
  extends: BaseStore,
  props: {
    taskId: {
      required: true,
      type: String
    },
    data: {
      required: true
    },
    shareData: {
      required: true
    },
    condition: {
      required: true,
      type: Object
    },
    dataTimeFormatter: {
      required: true
    },
    sources: {
      required: true,
      type: Array
    },
    site: {
      required: true,
      type: Object
    }
  },
  computed: {
    formatFactorGroups () {
      const {factorMap, factorGroupMap} = this
      return Object.values(this.condition.factorIds.reduce((map, factorId) => {
        const factor = factorMap[factorId]
        const {parentId} = factor
        let newFactorGroup = map[parentId]

        if (!newFactorGroup) {
          const factorGroup = factorGroupMap[parentId]

          if (!factorGroup) {
            return map
          }

          newFactorGroup = map[parentId] = {
            id: parentId,
            name: factorGroup.name,
            children: []
          }
        }

        newFactorGroup.children.push({
          id: factorId,
          name: factor.name
        })

        return map
      }, {}))
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/ResultComponents/BaseResult.js